/**
 * page.wl-tumblers-bottles のみ: DL_ScrollAction がビュー外で sa-active を外さないよう data-remove を付与。
 * dl-*.js は変更しない。
 */
(function () {
  document.querySelectorAll("#MainContent .dl-js-sa").forEach(function (el) {
    el.setAttribute("data-remove", "false");
  });
})();
